import { Section, Row, Col } from 'components/grid'
import React from 'react'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'
import { graphql, useStaticQuery } from 'gatsby'
import { ToolkitQueryEdge } from 'pages/intervention'
import ToolkitTabs from 'components/intervention/ToolkitTabs'
import SectionTitle from 'components/global/SectionTitle'
import { Carousel } from 'react-responsive-carousel'
import { StaticImage } from 'gatsby-plugin-image'

export default function FoundationalSkillsToolkits({ ...props }) {
	const data = useStaticQuery<ToolkitQuery>(query)

	const { fstk } = data

	return (
		<Section id={formatSectionId(props)} className="mt-20 scroll-mt-14">
			<SectionTitle
				title="Foundational Skills Toolkits"
				text="Foundational Skills Toolkits are designed for high-dosage, differentiated small-group tutoring and intervention by
the classroom teacher and/or other educators. Explicit skills instruction includes phonological and phonemic awareness, phonics, encoding/decoding, word study, fluency, and spelling."
			/>
			<Row className="mb-8">
				<Col>
					<Carousel showThumbs={false} dynamicHeight showStatus={false} infiniteLoop showIndicators>
						<div className="rounded-lg bg-gray-100">
							<StaticImage src="../../../../static/images/intervention/scope-and-sequence.png" alt="scope and sequence" />
						</div>
						<div className="rounded-lg bg-gray-100">
							<StaticImage src="../../../../static/images/intervention/student-materials.png" alt="student materials" />
						</div>
						<div className="rounded-lg bg-gray-100">
							<StaticImage src="../../../../static/images/intervention/teacher-materials.png" alt="teacher materials" />
						</div>
					</Carousel>
				</Col>
			</Row>
			<Row>
				<Col>
					<ToolkitTabs showFrameworks toolkits={fstk} />
				</Col>
			</Row>
		</Section>
	)
}

interface ToolkitQuery {
	fstk: ToolkitQueryEdge
}

const query = graphql`
	query {
		fstk: allContentfulToolkit(filter: { type: { eq: "Foundational Skills" } }) {
			edges {
				node {
					...toolkit
				}
			}
		}
	}
`
